import { useState, useEffect } from 'react';
import { rolesAPI } from '@/services';
import { formatIamRoleLabel } from '../utils/iamRoles';

/** Options de secours si l’API rôles est indisponible (même ordre que le catalogue backend). */
export const FALLBACK_ASSIGABLE_ROLES = [
  { key: 'org_admin', label: 'Administrateur organisation' },
  { key: 'org_manager', label: 'Manager organisation' },
  { key: 'executive', label: 'Rôle exécutif' },
  { key: 'finance_lead', label: 'Responsable finances' },
  { key: 'operations_lead', label: 'Responsable opérations' },
  { key: 'secretary', label: 'Secrétaire' },
  { key: 'compliance_officer', label: 'Membre suivi & adhésion' },
  { key: 'auditor', label: 'Membre surveillance' },
  { key: 'participant', label: 'Participant' },
];

/**
 * Rôles connus du projet (GET /roles ou /roles/list via proxy Entrea) :
 * modèles + rôles observés en base + éventuellement rôles imposés par le projet.
 */
export function useAssignableRoles() {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        let res;
        try {
          res = await rolesAPI.getList();
        } catch {
          res = await rolesAPI.getAll();
        }
        const data = res?.data;
        let list = [];
        if (Array.isArray(data?.roles_list)) {
          list = data.roles_list;
        } else if (data?.roles && typeof data.roles === 'object') {
          list = Object.values(data.roles);
        } else if (Array.isArray(data?.roles)) {
          list = data.roles;
        } else if (Array.isArray(data)) {
          list = data;
        }
        const normalized = list
          .map((r) => {
            if (typeof r === 'string') {
              return { key: r, label: formatIamRoleLabel(r) };
            }
            const key = r.key ?? r.name ?? r.id;
            if (!key) return null;
            return {
              key: String(key),
              label: r.label ? String(r.label) : formatIamRoleLabel(key),
            };
          })
          .filter(Boolean);
        if (!cancelled) {
          setRoles(normalized.length > 0 ? normalized : FALLBACK_ASSIGABLE_ROLES);
        }
      } catch {
        if (!cancelled) setRoles(FALLBACK_ASSIGABLE_ROLES);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { roles, loading };
}
